import React from 'react';
import Links from 'models/Links';
import { getCurrentLanguage } from 'components/contexts/LocalizationContext';

const PlayStoreBadge = () => {
	const localeString = getCurrentLanguage();

	return (
		<a className='store-badge' href={Links.PlayStore}>
			<div className={'store-badge-image play-store-badge ' + localeString} />
		</a>
	)
}

export default PlayStoreBadge;
